import useApiRequest from 'api/useApiRequest';
import { fetchSharedContent } from 'api/services/shareLinkService';

const useSharedContent = () => {
  const { request } = useApiRequest();

  const getSharedContent = async ({ code, signal }) => {
    const { data } = await fetchSharedContent(request, { code, signal });
    return data;
  };

  return { getSharedContent };
};

export default useSharedContent;
